import { render } from "./SelfReviewResponses.vue?vue&type=template&id=5dc67a20&scoped=true"
import script from "./SelfReviewResponses.vue?vue&type=script&lang=js"
export * from "./SelfReviewResponses.vue?vue&type=script&lang=js"

import "./SelfReviewResponses.vue?vue&type=style&index=0&id=5dc67a20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc67a20"]])

export default __exports__